module.exports = __webpack_public_path__ + "img/logo1200x360.ff0535e3.png";